import React, { useState, useEffect, useMemo } from 'react';
import { bool, func, number } from 'prop-types';
import {Loading, Modal, TableCustom, AdvancedSearch, InputFormat, InputTasa, InputWithEnterEvent} from '../../common';
import { ServerRequest } from '../../../utils/apiweb';
import { CloneObject } from '../../../utils/helpers';
import { APIS } from '../../../config/apis';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, openWithSession, useForm } from '@laramie/ui';

import '@laramie/ui/dist/components/controls/SubTasasModal/index.css';
import { useEntidad } from '../../hooks/useEntidad';
import { APPCONFIG } from '../../../app.config';
import {TIPS} from "../../../consts/tips";

const SubTasasModal = (props) => {

  //hooks
  const [state, setState] = useState({
      showMessage: false,
      loading: false,
      list: []
  });

  const seleccionadas = useMemo(() => state.list.filter(f => f.selected === true), [state.list]);

  const [filters, setFilters] = useState({
      labels: [
          { title: 'Tasa', field: 'descTasa', value: '', valueIgnore: '', fieldOriginal: 'idTasa', valueIgnoreOriginal: 0},
          { title: 'Código', field: 'codigo', value: '', valueIgnore: ''},
          { title: 'Descripción', field: 'descripcion', value: '', valueIgnore: '' }
      ]
  });

  const [ formValues, formHandle, , formSet] = useForm({
      idTasa: 0,
      descTasa: '',
      codigo: '',
      descripcion: ''
  });

  useEffect(() => {

    if (props.idTasa) {
      formSet({...formValues,
        idTasa: props.idTasa
      });
      if (props.idTasa > 0) {
        SearchSubTasas(props.idTasa);
      }
    }

  }, [props.idTasa]);


  const [, getRowEntidad] = useEntidad({
    entidades: ['Tasa'],
    onLoaded: (entidades, isSuccess, error) => {
      if (!isSuccess) {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'Tasa',
      timeout: 0
    }
  });

  const getDescTasa = (id) => {
    const row = getRowEntidad('Tasa', id);
    return (row) ? `${row.codigo} - ${row.descripcion}` : '';
  } 

  //definiciones
  const cellA = (props) =>    <div className='action'>
                                <div onClick={ (event) => handleClickAdd() } className="link">
                                    <span className="material-symbols-outlined" title="Nuevo">add</span>
                                </div>
                              </div>
  const cellS = (props) =>    <div className='action'>
                                <div onClick={ (event) => handleClickSelect(props.value) } className="link">
                                <span className="material-symbols-outlined" title="Seleccionar">west</span>
                                </div>
                              </div>
  const cellV = (props) =>    <div className='action'>
                                <div onClick={ (event) => handleClickView(props.value) } className="link">
                                <span className="material-symbols-outlined" title="Ver">search</span>
                                </div>
                              </div>

  const tableColumns = [
    ...(props.multiple ? [] : [{ Header: '', Cell: cellS, id:'select', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }]),
    { Header: 'Tasa', Cell: (props) => { return getDescTasa(props.value); }, accessor: 'idTasa', width: '40%' },
    { Header: 'Sub tasa', Cell: (props) => {
        const row = props.row.original;
        const descripcionTasa = `${row.codigo} - ${row.descripcion}`;
        return descripcionTasa;
      }, id: 'subTasa', accessor: 'id', width: '50%' },
    { Header: cellA, Cell: cellV, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
  ];


  //handles
  const handleClickSelect = (id) => {
    const row = state.list.find(f => f.id === id);
    props.onConfirm(id, CloneObject(row));
  }
  const toggleSeleccion = (id) => {
    setState(prevState => ({
      ...prevState,
      list: prevState.list.map(f => f.id === id ? {...f, selected: !f.selected} : f)
    }));
  }
  const onItemsSelected = (selected) => {
    setState(prevState => ({
      ...prevState,
      list: prevState.list.map(f => {
        const update = selected.find(x => x.id === f.id);
        return (update) ? {...f, selected: update.selected} : f;
      })
    }));
  }
  const handleClickAgregarSeleccionados = () => {
    // CloneObject usa Object.assign: hay que clonar cada fila, no el arreglo
    props.onConfirmMultiple(seleccionadas.map(CloneObject));
  }
  const handleClickAdd = (id) => {
    openWithSession(APIS.URLS.SESION, APPCONFIG.SITE.WEBAPP + 'unauthorized', `${APPCONFIG.SITE.WEBAPP}sub-tasa/nh/new`)
  }
  const handleClickView = (id) => {
    openWithSession(APIS.URLS.SESION, APPCONFIG.SITE.WEBAPP + 'unauthorized', `${APPCONFIG.SITE.WEBAPP}sub-tasa/nh/view/${id}`)
  }

  const handleClickSinSeleccion = () => {
    props.onConfirm(0, null);
  }

  //callbacks
  const callbackNoSuccess = (response) => {
    response.json()
    .then((error) => {
      const message = error.message;
      ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
      setState(prevState => {
        return {...prevState, loading: false};
      });
    })
    .catch((error) => {
        const message = 'Error procesando respuesta: ' + error;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
          return {...prevState, loading: false};
        });
    });
  }
  const callbackError = (error) => {
    const message = 'Error procesando solicitud: ' + error.message;
    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
    setState(prevState => {
      return {...prevState, loading: false};
    });
  }

  //funciones
  function SearchSubTasas(idTasa = null) {

    setState(prevState => {
        return {...prevState, loading: true, list: []};
    });
    
    const callbackSuccess = (response) => {
        response.json()
        .then((data) => {
            
            setState(prevState => {
                return {...prevState, loading: false, list: data};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    };

    let paramsUrl = `/filter?`+
    `idTasa=${(idTasa) ? idTasa : formValues.idTasa}&`+
    `codigo=${encodeURIComponent(formValues.codigo)}&`+
    `descripcion=${encodeURIComponent(formValues.descripcion)}&`+
    `etiqueta=`;
    
    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.SUB_TASA,
        paramsUrl,
        null,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );        
}

  function ApplyFilters() {
      UpdateFilters();
      SearchSubTasas();
  }
  function UpdateFilters() {
      let labels = [...filters.labels];
      labels.forEach((label) => {
          label.value = formValues[label.field];
      });
      setFilters(prevState => {
          return {...prevState, labels: labels};
      });
  }


  return (
    <div className='sub-tasa-modal'>

      <Loading visible={state.loading}></Loading>

      <Modal
        size="xl"
        title="Selección de Sub tasa"
        tipName={TIPS.NAME.MODALS.SELECCION_SUB_TASA_MODAL}
        onEscape={() => props.onDismiss()}
        body={(<>

            <AdvancedSearch
                formValues={formValues}
                formSet={formSet}
                labels={filters.labels.filter(f => f.value !== f.valueIgnore)}
                onSearch={ApplyFilters}
            >

                <div className='row form-basic'>
                    <div className="col-12 col-md-6 col-lg-4">
                        <label htmlFor="idTasa" className="form-label">Tasa</label>
                        <InputTasa
                            name="idTasa"
                            placeholder=""
                            className="form-control"
                            value={ formValues.idTasa }
                            onChange={({target}) =>{
                              let idTasa = 0;
                              let descTasa = '';
                              if (target.row) {
                                idTasa = parseInt(target.value);
                                descTasa = target.row.descripcion;
                              }
                              formSet({...formValues, idTasa: idTasa, descTasa: descTasa});
                          }}
                            disabled={!!props.idTasa}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <label htmlFor="codigo" className="form-label">Código</label>
                        <InputWithEnterEvent
                            useInputFormat={true}
                            name="codigo"
                            placeholder=""
                            className="form-control"
                            maskPlaceholder={null}
                            value={ formValues.codigo }
                            onChange={ formHandle }
                            onEnter={ApplyFilters}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <label htmlFor="descripcion" className="form-label">Descripción</label>
                        <InputWithEnterEvent
                            name="descripcion"
                            type="text"
                            placeholder=""
                            className="form-control"
                            value={ formValues.descripcion }
                            onChange={ formHandle }
                            onEnter={ApplyFilters}
                        />
                    </div>
                </div>

            </AdvancedSearch>

              <TableCustom
                  className={'TableCustomBase m-top-30'}
                  columns={tableColumns}
                  data={state.list}
                  useSelectedField={props.multiple}
                  onItemsSelected={onItemsSelected}
                  selectionLabelAccessor={(item) => `${item.codigo} - ${item.descripcion}`}
                  onClickRow={({ original }, colId) => {
                    if (colId === 'abm') return;
                    if (props.multiple) toggleSeleccion(original.id);
                    else props.onClickRow(original.id, original, colId);
                  }}
              />

        </>)}
        footer={(
              <div className='footer-action-container'>
                {props.multiple
                  ? <button className="btn btn-primary float-end" data-dismiss="modal" disabled={seleccionadas.length === 0} onClick={ (event) => handleClickAgregarSeleccionados() }>
                      Agregar seleccionados{seleccionadas.length > 0 && ` (${seleccionadas.length})`}
                    </button>
                  : <button className="btn btn-outline-primary float-end" data-dismiss="modal" onClick={ (event) => handleClickSinSeleccion() }>Sin selección</button>
                }
                <button className="btn back-button float-start" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
              </div>
        )}
      />

    </div>
  );
}

SubTasasModal.propTypes = {
  idTasa: number,
  multiple: bool,
  onConfirm: func,
  onConfirmMultiple: func,
  onDismiss: func.isRequired
};

SubTasasModal.defaultProps = {
  idTasa: null,
  multiple: false,
  onConfirm: null,
  onConfirmMultiple: null
};

export default SubTasasModal;
